/** A view flag only; record ownership is still authorized by the API. */
export const isRecordReview = (search: string) => new URLSearchParams(search).get('review') === '1';

export const recordReviewSearch = (search: string) => isRecordReview(search) ? '?review=1' : '';

export const assertRecordWritable = () => {
  const search = window.location.hash.split('?')[1] || '';
  if (isRecordReview(search)) {
    throw new Error('学生学习记录为只读查看，不能保存或交卷。');
  }
};
